// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mQ-z","isFullWidth":"nQ-z","landingPageVideo":"oQ-z","play":"pQ-z","iframeVideo":"qQ-z","playHidden":"rQ-z","fullwidth":"sQ-z"};